import React, { Component } from 'react';
import { debounce } from '../../../../js/utils';
import './auto-complete.scss';

const defaultProps = {
  defaultShowAll: true,
  startMatchLenth: 1,
  className: '',
  placeholder: '',
  unmatchedDesc: '暂无匹配结果',
  valueKey: 'value',
  uniqKey: '',
  onSelectList: () => {}
};

export default class AutoComplete extends Component {
  constructor(props) {
    super(props);
    this.autoCompleteRef = React.createRef();
    this.inputRef = React.createRef();
    this.state = {
      active: false,
      select: {},
      value: '',
      filterList: []
    };

    this.onClickOutside = this.onClickOutside.bind(this);
    this.filterFn = debounce(value => this.filter(value), 300);
  }

  componentDidMount() {
    this.setValue(this.props.defaultValue);
  }

  onActive() {
    if (this.state.active) return;
    this.inputRef.current.focus();
    this.setState({
      active: true
    });
    this.filter(this.state.value);
  }

  // 点击除自动补全元素以外的区域时消失下拉列表
  onClickOutside(event) {
    event.persist();
    setTimeout(() => {
      // console.log(event);
      // if (
      //   !event
      //   || (event.target !== this.autoCompleteRef.current
      //   && !this.autoCompleteRef.current.contains(event.target))
      // ) {
      //   console.log(this.state.select);
      // this.inputRef.current.blur();
      this.setState(prevState => ({
        value: prevState.select[this.props.valueKey] || '',
        active: false
      }));
      // }
    }, 100);
  }

  onSelect(data, isParent) {
    let obj = data;
    if (isParent) {
      obj = Object.assign({
        id: data.parkinglotid,
        name: data.parkinglotname
      }, data);
    } else {
      this.props.onSelectList(data);
    }

    this.setState({
      select: obj,
      active: false,
      value: obj[this.props.valueKey]
    });
  }

  onInputChange(e) {
    const value = e.target.value;
    this.setValue(value);

    if (value.length < this.props.startMatchLenth) {
      this.filterFn(!value || value.length === 0 ? this.props.data : []);
      return;
    }
    if (this.props.onChange) {
      this.props.onChange(value);
    } else {
      this.filterFn(value);
    }
  }

  setValue(value) {
    this.setState({
      value
    });
  }

  setFilterList(list) {
    this.setState({
      filterList: list
    });
  }

  filter(value) {
    this.setFilterList(
      Array.isArray(value)
        ? value
        : this.props.data.filter(
          item => !value || item[this.props.valueKey].indexOf(value) >= 0
        )
    );
  }

  render() {
    const { active, value } = this.state;
    const {
      themeType,
      className,
      placeholder,
      valueKey,
      onBlur,
      data,
      uniqKey,
      unmatchedDesc,
      onSelectList,
      onChange,
      defaultShowAll,
      startMatchLenth,
      defaultValue,
      ...resetProps
    } = this.props;
    const cls = [className, 'auto-complete', active ? 'auto-complete--active' : ''].join(' ');

    const themeClass = themeType === 'dark' ? 'auto-complete-wrapper dark-complete' : 'auto-complete-wrapper light-complete';

    return (
      <div className={themeClass} ref={this.autoCompleteRef}>
        <div className={cls} onClick={() => this.onActive()}>
          <input
            type="text"
            className="auto-complete-input"
            placeholder={placeholder}
            ref={this.inputRef}
            value={value || ''}
            onChange={e => this.onInputChange(e)}
            onBlur={this.onClickOutside}
            {...resetProps}
          />
        </div>
        <div className={['auto-complete-list', active ? 'auto-complete-list--active' : ''].join(' ')}>
          <ul>
            {
              this.state.filterList.length > 0
                ? this.state.filterList.map(item => (
                  <li
                    className="auto-complete-list-item"
                    key={item[uniqKey || valueKey]}
                    onClick={() => this.onSelect(item)}
                  >
                    {item[valueKey]}
                  </li>
                ))
                : (
                  <li
                    className="auto-complete-list-item"
                  >
                    {unmatchedDesc}
                  </li>
                )
            }
          </ul>
        </div>
      </div>
    );
  }
}

AutoComplete.defaultProps = defaultProps;
